import { createSlice } from "@reduxjs/toolkit";
import { addDishesAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addDishesSlice = createSlice({
  name: "addDishes",
  initialState: data,
  reducers: {
   addDishesSlice(state) {
      state.isLoading = true;
    },
   addDishesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addDishesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addDishesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const addDishesHandler: any = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addDishesAction.addDishesSlice());
    const response: any = await addDishesAPI(data);
    
    dispatch(addDishesAction.addDishesSliceSuccess(response));
  } catch (e: any) {
    dispatch(addDishesAction.addDishesSliceFailure(e?.response?.data));
  }
};

export default addDishesSlice.reducer;
export const addDishesAction = addDishesSlice.actions;